<template>
	<div>
		<sBox title="Grade de departamentos">
			<div slot="tools">
				<aBtn
					action="private-save-departments"
					text="Categoria"
					icon="plus"
					size="sm"
					type="success"
					@click="(data) => $refs.mdl.open()"
				/>
			</div>
			<div slot="body">
				<br />
				<div class="row">
					<div class="pull-right col-sm-4">
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-search"></i>
							</span>
							<input
								type="text"
								@input="filter($event.target.value)"
								placeholder="Pesquisar"
								class="form-control"
							/>
						</div>
					</div>
				</div>
				<br />
				<sTable
					ref="tab"
					actionRead="private-read-departments"
					actionDelete="private-delete-departments"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.mdl.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="mdl" @updata="$refs.tab.updateTable()" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';

	import pad from 'js/pad';

	export default {
		name: 'AppCadastroCategorias',
		components: { sTable, sBox, aBtn, modal },
		data() {
			return {
				labels: [
					{ data: 'cod', label: 'Cod' },
					{ data: 'titulo', label: 'Categorias' },
				],
				functions: [
					{
						cod: 'cod',
						fx: (val) => {
							return pad(val, 5);
						},
					},
				],
			};
		},
		methods: {
			filter(data) {
				if (data != '') {
					this.$refs.tab.setFilter(`
							cod like '%${data}%' or 
							titulo like '%${data}%'
					`);
				} else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
		},
		mounted() {
			this.$emit('setHeader', ['Departamentos', '']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/departments/index.vue